module.exports = __webpack_public_path__ + "static/media/21ECLAC17.95d75ab7.jpg";